// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inv-sel-cbo {
  width: 120px;
}

.inv-sel-btn {
  width: 15px;
  height: 30px;
}

.inv-sel-adv-tb {
  width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/shared/search/inventory-selector/inventory-selector.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AACA;EACI,WAAA;EACA,YAAA;AAEJ;;AAAA;EACI,YAAA;AAGJ","sourcesContent":[".inv-sel-cbo {\n    width: 120px;\n}\n.inv-sel-btn {\n    width:15px;\n    height:30px;\n}\n.inv-sel-adv-tb {\n    width:400px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
